import cn from 'classnames'
import s from './ProductTile.module.scss'
import loaderS from './LoaderTile.module.scss'

export const LoaderTile = (): JSX.Element => (
    <div
        className={cn(s['productitem-block'])}
        data-testid="product-tile-loader"
        aria-hidden
    >
        <div
            className={cn(loaderS.skeleton, loaderS.image, s['product-img'])}
        />
        <div className={cn(loaderS.skeleton, loaderS.line)} />
        <div
            className={cn(
                loaderS.skeleton,
                loaderS.line,
                loaderS['line-short']
            )}
        />
        <div className={loaderS.circles}>
            <span className={cn(loaderS.skeleton, loaderS.circle)} />
            <span className={cn(loaderS.skeleton, loaderS.circle)} />
        </div>
    </div>
)
